import React from 'react'

export const Error404 = () => {
    return <div className='error'>404 Page not found</div>

}